import React, { FC } from 'react';
import { useTranslation } from 'hooks/use-translation';
import { text } from '../combiner';
import { GroupedCriteria } from '../criteria';
import { getDefaultCriteria } from '../criteria/get-default-criteria';
import { FilterableField, GroupedOptions } from '../fields';
import { GroupedFilter } from '../grouped-filter-popover';
import { AddFilterButton, AdvancedBoxWrapper, Row } from './components';
import {
  GetFilterOperationTypeOptions,
  GetOperationOptionRenderer,
  GetSelectEditorComponents,
} from './utils';

export interface Props {
  hideMatchTypeText?: boolean;
  addButtonText?: string;
  fields: GroupedOptions<FilterableField>[];
  filter: GroupedFilter;
  onChange: (filter: GroupedFilter) => void;
  getFilterOperationTypeOptions?: GetFilterOperationTypeOptions;
  getSelectEditorComponents?: GetSelectEditorComponents;
  getOperationOptionRenderer?: GetOperationOptionRenderer;
}

export const AdvancedGroupedFilterComponent: FC<Props> = ({
  fields,
  filter,
  onChange,
  getFilterOperationTypeOptions,
  getSelectEditorComponents,
  hideMatchTypeText = false,
  addButtonText,
  getOperationOptionRenderer,
}) => {
  const default_text = useTranslation('task_list.filters.add');
  const add_filter = addButtonText ?? default_text;

  return (
    <>
      <AdvancedBoxWrapper>
        {filter.groupCriteria.map((f, i) => (
          <Row key={`${f.criteria.field.fieldId}_${String(i)}`}>
            <GroupedCriteria
              hideMatchTypeText={hideMatchTypeText}
              onRemove={() =>
                onChange({
                  ...filter,
                  groupCriteria: filter.groupCriteria.filter((_, j) => i !== j),
                })
              }
              text={text(i, filter.type)}
              fields={fields}
              filter={f}
              getFilterOperationTypeOptions={getFilterOperationTypeOptions}
              getSelectEditorComponents={getSelectEditorComponents}
              onChange={(g) =>
                onChange({
                  ...filter,
                  groupCriteria: filter.groupCriteria.map((x, j) =>
                    i !== j ? x : g,
                  ),
                })
              }
              getOperationOptionRenderer={getOperationOptionRenderer}
            />
          </Row>
        ))}
        {filter.groupCriteria.length === 0 && (
          <Row>
            <GroupedCriteria
              hideMatchTypeText={hideMatchTypeText}
              text={text(filter.groupCriteria.length, filter.type)}
              fields={fields}
              getFilterOperationTypeOptions={getFilterOperationTypeOptions}
              getSelectEditorComponents={getSelectEditorComponents}
              onChange={(g) =>
                onChange({
                  ...filter,
                  groupCriteria: filter.groupCriteria.concat(g),
                })
              }
            />
          </Row>
        )}
      </AdvancedBoxWrapper>
      {filter.groupCriteria.length > 0 && (
        <Row>
          <AddFilterButton
            data-cy="add.filter"
            onClick={() =>
              onChange({
                ...filter,
                groupCriteria: filter.groupCriteria.concat({
                  id: filter.groupCriteria[0].id,
                  criteria: getDefaultCriteria(fields[0].options[0]),
                }),
              })
            }
          >
            {add_filter}
          </AddFilterButton>
        </Row>
      )}
    </>
  );
};
